<template>
  <div class="organ-device-auto-bd ubv">
    <div class="tip">
      <i class="icon icon-tishi"></i>
      <span>{{ $t('base_organ_device_auto.ygkglckjrdkwygsgtjjq') }}</span>
    </div>
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item>
          <el-button type="primary" icon="el-icon-plus" :disabled="disableJoinOrg" v-if="funcView.depuser_user_join_orgdeploc" @click="openBindGroup">{{ $t('base_organ_device_auto.jrzzbmxm') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-minus" v-if="funcView.depuser_user_quit_orgdeploc" :disabled="!tableSelect.length" @click="onUnbindGroup(tableSelect, true)">
            {{ $t('base_organ_device_auto.tczzbmxm') }}
          </el-button>
        </el-form-item>
        <!-- 配置表格列 -->
        <el-form-item style="float: right; margin-right: 0">
          <custom-column ref="column"></custom-column>
        </el-form-item>
        <!-- 搜索栏 -->
        <el-form-item style="float: right">
          <search-input :placeholder="$t('base_organ_device_auto.zzmcbh')" v-model="formSearch.search" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-bd">
      <custom-table height="100%" type="checkbox" v-model="tableSelect" tableCode="user_distribution" :data="tableList" @column="setColumn" @filter="filterChange" @sort="sortChange">
        <template slot="action" slot-scope="scope">
          <el-button type="text" size="mini" @click="onUnbindGroup([scope.row])">{{ $t('base_organ_device_auto.tui_chu') }}</el-button>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
    <organ-group-dialog v-if="dialogVisible" :model="dialogModel" :orgId="orgId" @close="dialogVisible = false" @success="onSuccess"></organ-group-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import organGroupDialog from '@/pages/base/components/organGroupDialog';

export default {
  components: { organGroupDialog },
  props: {
    orgId: [String, Number],
    userId: {
      // 兼容新增用户第3步
      type: [String, Number, Boolean],
      default: '',
    },
    user: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      tableSelect: [],
      formSearch: {
        userId: '',
        search: '',
        orderBy: '',
        orderType: '',
        pageSize: 20,
        pageNum: 1,
      },
      tableList: [],
      totalRows: 0,
      dialogVisible: false,
      dialogModel: {},
    };
  },
  watch: {
    user: function () {
      this.formSearch = JSON.parse(this.resetFormSearch);
      this.tableList = [];
      this.totalRows = 0;
      this.getOrganChildren();
    },
  },
  computed: {
    loginOrgId() {
      const userInfo = this.$store.state.userInfo;
      return userInfo ? userInfo.rootOrgId : '';
    },
    disableJoinOrg() {
      const curOrgId = this.orgId || this.loginOrgId;
      return this.tableList.findIndex((t) => t.orgId === curOrgId && t.toBizType === 1) !== -1;
    },
  },
  mounted: function () {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getFuncView('/company/organdevice');
    this.getOrganChildren();
  },
  methods: {
    onSuccess() {
      this.$emit('success');
      this.getOrganChildren();
    },
    // 获取已关联组织、分组
    getOrganChildren() {
      this.formSearch.userId = this.user.userId || this.userId;
      this.$getJSON(apis.OrganAutoBindByUser, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 取消关联组织、分组
    onUnbindGroup: function (rows, checkbox) {
      const tip = checkbox ? this.$t('base_organ_device_auto.nqdyjxzdyhcxzdzzbmxm') : this.$t('base_organ_device_auto.nqdyjxzdyhcxzdzzbmxm');
      this.$showConfirm(tip)
        .then(() => {
          this.cancelDevice(rows);
        })
        .catch(() => {});
    },
    // 取消关联组织、分组
    cancelDevice: function (rows) {
      const bindAutomaticIds = rows.map((t) => ({
        orgId: t.orgId,
        bizId: t.bizId,
        bizType: t.bizType,
        toBizId: t.toBizId,
        toBizType: t.toBizType,
      }));
      this.$postJSON(apis.organDeviceBindAutoDel, bindAutomaticIds).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.$emit('success');
        this.getOrganChildren();
      });
    },
    // 关联组织/分组
    openBindGroup: function () {
      this.dialogModel.title = this.$t('base_organ_device_auto.jrzzbmxm');
      this.dialogModel.userId = this.user.userId || this.userId;
      this.dialogVisible = true;
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getOrganChildren();
    },
  },
};
</script>

<style lang="scss">
@import 'style/colors.scss';

.organ-device-auto-bd {
  padding: 0 16px;
  height: 100%;
  .tip {
    background: rgba(254, 244, 219, 1);
    padding-left: 10px;
    margin-top: 16px;
    .icon {
      color: #eebf4d;
      font-size: 12px;
      margin-right: 10px;
    }
    span {
      line-height: 32px;
      color: #6c757d;
      font-size: 12px;
    }
  }
}
</style>
